import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import customRoutesSrc from './images/custom-routes-thumb.avif';

const customRoutes = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Custom Routes' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Start from scratch or customize to create your perfect adventure in-app' }),
  thumbnailImage: customRoutesSrc.src
});

export default customRoutes;
